import { VNode } from 'vue';

import DesignComponent from './designComponent';

const ionLabel = new DesignComponent({
  structure: {
    tag: 'ion-label',
    text: 'List Item',
    isListItem: true
  }
});

const ionItem = new DesignComponent({
  structure: {
    tag: 'ion-item',
    children: [ionLabel.structure]
  }
});

export default new DesignComponent({
  info: {
    title: 'List',
    img: new URL('../../../assets/img/icons/list.svg', import.meta.url).href
  },
  structure: {
    tag: 'ion-list',
    text: 'List',
    data: {
      props: {
        designId: 'list',
        configurable: 'List'
      },
      attrs: {
        draggable: true
      }
    },
    children: [ionItem.structure, ionItem.structure]
  }
});
